<div class="editor-overlay" [style]="styles" [class.editor-overlay--open]="isOpened">
    <div
        class="editor-overlay__overlay"
        [@fadeOverlay]="show ? 'open' : 'closed'"
        (@fadeOverlay.done)="animationDone($event)"
    ></div>
    <div class="editor-overlay__container" [@toggleContent]="show ? 'open' : 'closed'">
        <div class="editor-overlay__title" *ngIf="!!title">
            {{ title }}
            <button type="button" class="editor-overlay__close-icon" (click)="handleClose()">
                <img src="/assets/icons/remove-icon.svg" alt="Close" />
            </button>
        </div>
        <div class="editor-overlay__content" [style]="contentStyles">
            <ng-content></ng-content>
        </div>
        <div class="editor-overlay__buttons">
            <button
                class="editor-overlay__button"
                (click)="openCancelModal()"
                [disabled]="processing"
            >
                Cancel
            </button>
            <button
                [disabled]="disablePrimaryButton"
                class="editor-overlay__button editor-overlay__button--primary"
                (click)="!(disablePrimaryButton && processing) && handleSave()"
            >
                <ng-container *ngIf="processing">
                    <img
                        src="/assets/icons/spinner-icon.svg"
                        alt="spinner"
                        class="processing-icon animation-spin"
                    />
                    Saving...
                </ng-container>
                <ng-container *ngIf="!processing">Save</ng-container>
            </button>
        </div>
    </div>
    <mapp-action-modal
        #cancelModal
        class="centered"
        [title]="'Are you sure you want to cancel?'"
        [description]="'You will lose all changes.'"
        [iconPath]="'/assets/icons/warning-blue.svg'"
        [primaryButton]="cancelModalPrimaryButton"
        [secondaryButton]="cancelModalSecondaryButton"
    ></mapp-action-modal>
</div>
